import { useCallback, useEffect } from 'react';

let gtmInitialised = false;

const injectGtmOnce = (id: string, dataLayerName: string) => {
  if (gtmInitialised) return;
  gtmInitialised = true;

  const w = window as any;
  w[dataLayerName] = w[dataLayerName] || [];
  w[dataLayerName].push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  const dl = dataLayerName !== 'dataLayer' ? `&l=${dataLayerName}` : '';
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${id}${dl}`;
  document.head.insertBefore(script, document.head.firstChild);

  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${id}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  iframe.id = 'tag-manager';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
};

const useGtmEventTracking = () => {
  useEffect(() => {
    const id = process.env.REACT_APP_GTM_ID;
    const dataLayerName = process.env.REACT_APP_GTM_DATA_LAYER_NAME;
    if (!id || !dataLayerName) return;
    injectGtmOnce(id, dataLayerName);
  }, []);

  return useCallback((event: any) => {
    const dataLayerName = process.env.REACT_APP_GTM_DATA_LAYER_NAME || 'dataLayer';
    const dl = (window as any)[dataLayerName];
    if (dl) dl.push(event);
  }, []);
};

export default useGtmEventTracking;
